import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "IotPlatform"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 14.25H19.5V11.25H18V18H6V6H12.75V4.5H9.75V1.5H8.25V4.5H6C5.17192 4.50083 4.50083 5.17192 4.5 6V8.25H1.5V9.75H4.5V14.25H1.5V15.75H4.5V18C4.50083 18.8281 5.17192 19.4992 6 19.5H8.25V22.5H9.75V19.5H14.25V22.5H15.75V19.5H18C18.8279 19.4988 19.4988 18.8279 19.5 18V15.75H22.5V14.25ZM21.75 9.75H23.25C23.2446 4.78166 19.2183 0.755374 14.25 0.75V2.25C18.3901 2.25496 21.745 5.60992 21.75 9.75ZM15.75 15.75H8.25V8.25H15.75V15.75ZM9.75 14.25H14.25V9.75H9.75V14.25ZM19.5 9.75H18C17.9975 7.67996 16.32 6.00248 14.25 6V4.5C17.1481 4.50331 19.4967 6.85188 19.5 9.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/IotPlatform.vue"]]);
